import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
 

function ImageSlider({images}) {
  return (
    <div className="box">
      <Carousel showThumbs={false} autoPlay={true} interval={3000} infiniteLoop={true}>
        {images.map((URL, index) => (
          <div className="slide">
            <img alt="sample_file" key={index} src={URL.url}   />
          </div>
        ))}
      </Carousel>
    </div>
  );
}
export default ImageSlider;